import { usePlanCardContext } from '@aibees/shared/features/plan-card/context';
import { CreditInfo } from '../types';
import * as SX from '../sx';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { PlanInterval } from '@aibees/shared/definition';

export function useCreditsInformation(): CreditInfo[] {
  const { currentPlan, selectedPlan } = usePlanCardContext();
  const { data } = useCurrentSubscriptionApi();

  const userPlan = data?.current?.plan;

  return [
    {
      label: 'Current Balance',
      value: Number(data?.credit?.total) || 0,
      sx: SX.currentBalance,
    },
    {
      label: `Current Plan Credits /${
        currentPlan?.interval === PlanInterval.MONTH ? 'Monthly' : 'Yearly'
      }`,
      value: Number(userPlan?.metadata.request) || 0,
    },
    {
      label: 'Current Plan Roll Over Credit Cap',
      value: Number(userPlan?.metadata.rollover) || 0,
    },
    {
      label: `New Plan Credits /${
        selectedPlan?.interval === PlanInterval.MONTH ? 'Monthly' : 'Yearly'
      }`,
      value: Number(selectedPlan?.metadata.request) || 0,
    },
    {
      label: 'New Plan Roll Over Credit Cap',
      value: Number(selectedPlan?.metadata.rollover) || 0,
    },
    {
      label: 'Potentially Lost Credits',
      value:
        Number(data?.credit?.total) - Number(selectedPlan?.metadata.rollover),
      sx: SX.potentialyLostCredits,
    },
  ];
}
